import i18n from '@/utils/i18n';
import { List } from '@usepepper/sprout-kit-ui';
import { NavItemIcon } from '@/domain/navigation/types';
import { useTheme } from '@/contexts/theme-context';

const ICON_SIZE = 24;

interface MobileDrawerExperienceSwitchProps {
  icon?: NavItemIcon;
  label: string;
  onPress: () => void;
}

export const MobileDrawerExperienceSwitch: React.FC<
  MobileDrawerExperienceSwitchProps
> = ({ icon: Icon, label, onPress }) => {
  const theme = useTheme();

  return (
    <List.Item
      alignItems="center"
      onPress={onPress}
      paddingHorizontal="$16"
      pressable
    >
      {Icon ? (
        <List.Item.Leading>
          <Icon
            color={theme.sk.color.icon.primary}
            size={ICON_SIZE}
            stroke={theme.sk.color.icon.primary}
          />
        </List.Item.Leading>
      ) : null}
      <List.Item.Content>
        <List.Item.Title numberOfLines={1}>{label}</List.Item.Title>
      </List.Item.Content>
      <List.Item.Value color="$textSecondary" fontSize="$xs">
        {i18n.t('sales_portal.sidebar.switch')}
      </List.Item.Value>
    </List.Item>
  );
};
